module.exports = __webpack_public_path__ + "img/nav06.b79edd8c.png";